import type { InternalField } from '@atlassian/ui-modifications-core/types';

export const pickPropertiesToOverwrite = (
	field: Partial<InternalField>,
): Partial<InternalField> => {
	const overwriteProperties: (keyof InternalField)[] = [
		'fieldName',
		'description',
		'isReadOnly',
		'isRequired',
		'allowedValues',
	];

	return overwriteProperties.reduce((acc: Partial<InternalField>, propertyName) => {
		const propertyValue = field[propertyName];

		if (propertyValue !== undefined) {
			acc[propertyName] = propertyValue;
		}

		return acc;
	}, {});
};
